// extracted by mini-css-extract-plugin
export default {"blockFull":"fullInfoBlock_blockFull__XcY6N","description":"fullInfoBlock_description__0mrYT","data":"fullInfoBlock_data__rf2gz"};